import React from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
// import PDCReportDocument from "./PDCReportDocument";

// import PDCIssuedDocument from "./PDCIssuedDocument";

import Modal from "../../common/CommonModal";
import StockLedgerDocument from "./StockLedgerDocument";

const StockLedgerPrint = ({ pdcIssuedPrintDataFromAPI, setStockLedgerPrint , isStockLedgerPrint }) => {
  const onClose = () => {
    setStockLedgerPrint(false);
  };

  console.log("pdcIssuedPrintDataFromAPI:", pdcIssuedPrintDataFromAPI);
  return (
    <Modal
      isOpen={isStockLedgerPrint}
      onClose={() => setStockLedgerPrint(false)}
      title={"Stock Ledger"}
      size="xxl"
      header={true}
    >
      <div className="flex flex-col items-center h-screen">
        <div className="w-full h-[82vh] border border-gray-300 mb-4">
          <PDFViewer width="100%" height="100%">
            <StockLedgerDocument pdcIssuedPrintDataFromAPI={pdcIssuedPrintDataFromAPI} />
          </PDFViewer>
        </div>
      </div>
    </Modal>
  );
};

export default StockLedgerPrint;
